/* public-path Sets the cdn path of the chunks.  Must be the first import in this file */
import '~/common/public-path';
import '~library/organisms/MegaNav';
